import { ProjectInfo, TopProject } from '../../types/globalTypes';
import { API_BASE_URL } from '../../constants';
import axios from 'axios';

export const fetchProjectDetailsPage = async (
  projectName: string
): Promise<{ projectInfo: ProjectInfo; projectsList: TopProject[] } | null> => {
  try {
    const projectNameSpaces = projectName.replace(/_+/g, ' ');
    const response = await axios.get<{
      data: { projectInfo: ProjectInfo; projectsList: TopProject[] };
    }>(`${API_BASE_URL}/project/${projectNameSpaces}`);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching project and top projects:', error);
    return null;
  }
};
